/**
 * Undo an optimistic read for one failed mark request.
 * Snapshot maps are the comment and revision lists from before that request's START.
 * Marked ids go back in their previous order. Ids that arrived while the request
 * was in flight are appended. Ids a different action already removed stay removed.
 * @param {Object[]} items
 * @param {Object} newComments
 * @param {Object} newRevisions
 * @param {Object} snapshotComments
 * @param {Object} snapshotRevisions
 * @param {string[]} ids
 * @returns {{ updatedItems: Object[], updatedNewComments: Object, updatedNewRevisions: Object }}
 */
const restoreEventIdMap = (current = {}, snapshot = {}, restoreSet) => {
  const currentMap = current || {};
  const snapshotMap = snapshot || {};
  const restored = {};
  const keys = Object.keys(snapshotMap);

  Object.keys(currentMap).forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(snapshotMap, key)) keys.push(key);
  });

  keys.forEach((key) => {
    const previous = snapshotMap[key] || [];
    const now = currentMap[key] || [];
    const nowSet = new Set(now);
    const previousSet = new Set(previous);
    const nextIds = [];

    previous.forEach((id) => {
      if (restoreSet.has(id) || nowSet.has(id)) nextIds.push(id);
    });
    now.forEach((id) => {
      if (!previousSet.has(id)) nextIds.push(id);
    });

    if (nextIds.length || Object.prototype.hasOwnProperty.call(currentMap, key)) {
      restored[key] = nextIds;
    }
  });

  return restored;
};

const restoreNotificationUnread = (
  items = [],
  newComments,
  newRevisions,
  snapshotComments,
  snapshotRevisions,
  ids = [],
) => {
  const restoreSet = new Set(ids);
  const updatedItems = (items || []).map((item) => {
    if (restoreSet.has(item._id)) return { ...item, read: false };
    return item;
  });

  return {
    updatedItems,
    updatedNewComments: restoreEventIdMap(newComments, snapshotComments, restoreSet),
    updatedNewRevisions: restoreEventIdMap(newRevisions, snapshotRevisions, restoreSet),
  };
};

export default restoreNotificationUnread;
